import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/shared/services/global.service';

@Component({
    selector: 'app-service-notfound',
    templateUrl: './service-notfound.component.html',
    styleUrls: ['./service-notfound.component.scss'],
    standalone: false
})
export class ServiceNotfoundComponent implements OnInit {
  constructor(public globalService: GlobalService,
        private router: Router,
  ) {}

  ngOnInit(): void {
    this.globalService.serviceNotFound = true;
  }

  ChangeChurch() {
    this.globalService.Initialize();
    var timer = 0;
    if (this.globalService.datePicker != null) {
      this.globalService.datePicker.close(); 
      this.globalService.datePicker = null;
      timer = 150;
    }
    this.globalService.clearCurCache = true;
    this.globalService.isBack = false;
    setTimeout(async () => await this.JumpToChangeChurch(), timer);
  }  

  async JumpToChangeChurch() {
    this.router.navigate(['main/switch-tenant']);  
  }  
}
